module.exports = __webpack_public_path__ + "static/media/ic_play_white.88073ab4.svg";